"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
/*--------------------------------------------------------------------------------------------------------------
 *  Copyright (c) insite-gmbh. All rights reserved.
 *  Licensed under the Apache License, Version 2.0. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------------------------*/
const core_1 = require("@angular/core");
const plc_1 = require("../../../plc");
const plcInput_1 = require("../plcInput");
let PlcStateComponent = class PlcStateComponent extends plcInput_1.PlcInput {
    constructor(inaxPlc) {
        super(inaxPlc);
        this.intervalState = false;
        this._interval = 500;
        /* SPECIFIC INPUTS */
        this.trueValue = 'true';
        this.falseValue = 'false';
        this.trueValueMessage = 'Start';
        this.falseValueMessage = 'Stop';
        this.interval = '500';
    }
    get Value() {
        return this._value;
    }
    set Value(v) {
    }
    ngOnInit() {
        this.initializeDefaultProperties();
        this.initialize();
        this.subscribe();
    }
    ngOnDestroy() {
        this.unsubscribe();
        clearTimeout(this._timer);
    }
    /**
     * set the number specified by the string @Input() interval
     * if interval is not 0, the state-display will begin to blink
     */
    initialize() {
        this._interval = Number(this.interval);
        if (this._interval > 0) {
            this.blink();
        }
    }
    /**
     * while the current value equals trueValue, this function causes the intervalState
     * to alternate (resulting in the display blinking)
     * otherwise, the intervalState will always be set to false, so the display does not
     * blink and is turned off in case the value changed while it was on
     *
     * the function sets a timeout with the delay in milliseconds specified by this._interval
     * which will then call this function again
     */
    blink() {
        // while value equals trueValue, blink
        if (this._value === this.trueValue) {
            this.intervalState = !this.intervalState;
        }
        else {
            this.intervalState = false;
        }
        this._timer = setTimeout(() => this.blink(), this._interval);
        // console.log('BLINK');
    }
    /**
     * updates the current value
     * if interval is 0 (=> blinking is disabled), the state of the display is changed
     * to resemble the value (so it is 'on' if value === this.trueValue)
     */
    updateValue(value) {
        this._value = value;
        // if blinking is disabled, update state of display
        if (this._interval === 0) {
            this.intervalState = (value === this.trueValue);
        }
    }
};
__decorate([
    core_1.Input(),
    __metadata("design:type", String)
], PlcStateComponent.prototype, "trueValue", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", String)
], PlcStateComponent.prototype, "falseValue", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", String)
], PlcStateComponent.prototype, "trueValueMessage", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", String)
], PlcStateComponent.prototype, "falseValueMessage", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", String)
], PlcStateComponent.prototype, "interval", void 0);
PlcStateComponent = __decorate([
    core_1.Component(Object.assign({
        selector: 'plc-state',
        templateUrl: './@inax/plcUi/src/plcState/plc-state.component.html',
        styleUrls: ['./@inax/plcUi/src/plcState/plc-state.component.css']
    }, plcInput_1.PlcInput.metaData)),
    __metadata("design:paramtypes", [plc_1.InaxPlcService])
], PlcStateComponent);
exports.PlcStateComponent = PlcStateComponent;
